import { FC, useState } from 'react';
import { Button, ButtonPrimary, Modal, ModalActions, ModalProps } from '@lambdacurry/component-library';
import './confirm-modal.scss';

export interface ConfirmModalProps extends ModalProps {
  title?: string;
  text?: string;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const ConfirmModal: FC<ConfirmModalProps> = ({
  title = 'Confirm',
  text = 'Are your sure? This cannot be undone.',
  confirmButtonLabel,
  cancelButtonLabel,
  onConfirm,
  onCancel,
  ...props
}) => {
  const [confirming, setConfirming] = useState(false);

  const handleConfirm = async () => {
    setConfirming(true);
    await onConfirm();
    setConfirming(false);
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
  };

  return (
    <Modal id="confirm-modal" className="confirm-modal" closeButton={false} {...props}>
      {title && <h3 className="h4">{title}</h3>}
      {text && <p className="!mt-4">{text}</p>}

      <ModalActions className="!mt-6">
        <Button
          className="!flex-grow-0"
          onClick={handleCancel}
          disabled={confirming}
          data-cy="confirm-modal-cancel-button"
        >
          {cancelButtonLabel || 'Cancel'}
        </Button>
        <ButtonPrimary
          className="!flex-grow-0"
          onClick={handleConfirm}
          disabled={confirming}
          data-cy="confirm-modal-confirm-button"
        >
          {confirmButtonLabel || (confirming ? 'Confirming...' : 'Confirm')}
        </ButtonPrimary>
      </ModalActions>
    </Modal>
  );
};
